import noop from 'lodash/noop';
import { createActions } from 'redux-actions';

import type {
  FlowChatAddFlowPayloadT,
  FlowChatGetFlowPayloadT,
  FlowChatUpdateFlowPayloadT,
} from '../api/types';

export const chatFlowActions = createActions(
  {
    CHAT_FLOW_ADD: [
      (payload: FlowChatAddFlowPayloadT) => payload, // Payload
      (_payload, resolve = noop, reject = noop) => ({ resolve, reject }), // Meta
    ],
    CHAT_FLOW_GET: [
      (payload: FlowChatGetFlowPayloadT) => payload, // Payload
      (_payload, resolve = noop, reject = noop) => ({ resolve, reject }), // Meta
    ],
    CHAT_FLOW_EDIT: [
      (payload: FlowChatUpdateFlowPayloadT) => payload, // Payload
      (_payload, resolve = noop, reject = noop) => ({ resolve, reject }), // Meta
    ],
  },
  'CHAT_FLOW_ADD_SUCCEEDED',
  'CHAT_FLOW_ADD_FAILED',
  'CHAT_FLOW_GET_SUCCEEDED',
  'CHAT_FLOW_GET_FAILED',
  'CHAT_FLOW_EDIT_SUCCEEDED',
  'CHAT_FLOW_EDIT_FAILED',
  'CHAT_FLOW_ADD_AFTER_CHAT_WIDGET_CREATED',
  'CHAT_FLOW_ADD_ACTION_CLICKED',
  'CHAT_FLOW_CLEAR_STATE',
);
